<section class="evidence-section">
  <div class="section py-5 pt-lg-80 px-lg-5 position-relative" [ngStyle]="{'background-image': imagePath}">
    <div class="container">
      <h2 class="mb-4">{{data.tag_loader_title ?? ''}}</h2>
      <div class="row g-4">
        <div class="col-lg-6 col-xl-4" *ngFor="let taghighlighted of data.tag_loader_highlighted">
          <div class="card-wrapper border border-light rounded shadow-sm">
            <div class="card no-after rounded">
              <div class="card card-body">
                <h3 class="card-title">
                  <a class="text-decoration-none" [href]="taghighlighted?.path?.alias">
                    {{taghighlighted.title}}
                  </a>
                </h3>
                <p class="card-text text-secondary pb-3" [innerHTML]="substring(taghighlighted?.tag_body?.processed,0,255)"></p>
                <div class="link-list-wrapper mt-4" *ngIf="taghighlighted?.tag_related_tags && taghighlighted?.tag_related_tags.length > 0">
                  <ul class="link-list">
                    <li *ngFor="let relatedtag of cutArray(taghighlighted?.tag_related_tags)">
                      <a class="list-item active icon-left mb-2" [href]="relatedtag?.path?.alias">
                        <span class="list-item-title-icon-wrapper">
                          <span class="text-success">{{relatedtag?.title}}</span>
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <a class="read-more pt-0 px-4" [href]="taghighlighted?.path?.alias">
                <span class="text">Esplora argomento</span>
                <svg class="icon ms-0" aria-label="Esplora argomento">
                  <use href="bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div class="row pt-30">
          <div class="col-lg-10 col-xl-6 offset-lg-1 offset-xl-2">
            <div class="row d-lg-inline-flex">
              <div class="col-lg-3">
                <h3 class="text-uppercase mb-3 title-xsmall-bold text u-grey-light">Altri argomenti</h3>
              </div>
              <div class="col-lg-9">
                <ul class="d-flex flex-wrap gap-1">
                  <li *ngFor="let tag of data.tag_loader_tags">
                    <a class="chip chip-simple" [href]="tag?.path?.alias" data-focus-mouse="false">
                      <span class="chip-label">{{tag.title}}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2 text-center" *ngIf="data.tag_loader_anchor_link?.alias">
            <a [href]="data.tag_loader_anchor_link?.alias" class="btn btn-primary mt-40">{{data.tag_loader_anchor_link?.title}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- <section id="head-section">
  <h2 class="visually-hidden ">{{data.hero_title}}</h2>
  <div class="container placeholder-glow">
    <div class="row">
      <div class="col-lg-6 order-2 order-lg-1">
        <div class="card mb-5">
          <div class="card-body pb-5 px-0">
            <div class="category-top">
              <svg class="icon icon-sm icon-primary me-2" aria-hidden="true">
                <use xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-calendar"></use>
              </svg>
              <span class="title-xsmall-semi-bold fw-bold">Notizie</span>
              <span class="data fw-normal">{{data.created | date}}</span>
            </div>
            <a href="#" class="text-decoration-none" data-focus-mouse="false">
              <h3 class="card-title">{{data.hero_title}}
              </h3>
            </a>
            <p class="mb-4 pt-3 lora" [innerHTML]="data.hero_body.value"></p>
            <ng-container *ngIf="data.hero_tags.length > 0">
              <div *ngFor="let tag of data.hero_tags">
                <a class="chip chip-simple" [href]="tag.path?.alias">
                  <span class="chip-label">{{tag.title}}</span>
                </a>
              </div>
            </ng-container>
            <a class="read-more pb-3" [href]="data.hero_link?.alias"
              [target]="data.hero_link?.target_blank === true ? '_blank' : '_self'">
              <span class="text">{{data.hero_link?.title}}</span>
              <svg class="icon  icon-primary">
                <use xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-6 order-1 order-lg-2 px-0 px-lg-3" *ngIf="data.hero_image?.field_media_image?.uri?.url">
        <img [src]="data.hero_image?.field_media_image?.uri?.url" title="titolo immagine" alt="descrizione immagine"
          class="img-fluid" height="539px" width="960px">
      </div>
    </div>
  </div>
  <div class="section-muted pb-lg-50 px-lg-5 pt-0 bg-grey-card">
    <div class="container">
      <div class="row mb-2">
        <div
          class="card-wrapper px-0 card-overlapping card-teaser-wrapper card-teaser-wrapper-equal card-teaser-block-3">
          <ng-container *ngFor="let hl of data.hero_highlighted">
            <div
              class="card card-teaser card-teaser-image card-flex no-after rounded shadow-sm border border-light mb-0">
              <div class="card-image-wrapper with-read-more">
                <div class="card-body p-3 pb-5">
                  <div class="category-top">
                    <span class="title-xsmall-semi-bold fw-semibold">{{hl.news_type.name}}</span>
                  </div>
                  <h3 class="card-title text-paragraph-medium u-grey-light">{{hl.title}}</h3>
                  <p class="text-paragraph-card u-grey-light m-0">{{substring(hl.news_description,0,155)}}</p>
                </div>
                <div class="card-image card-image-rounded pb-5" *ngIf="hl?.news_image.field_media_image?.uri?.url">
                  <img
                    [src]="hl?.news_image.field_media_image?.uri?.url ? getthumbnail(hl?.news_image.field_media_image?.uri?.url) : ''"
                    [title]="hl?.news_image?.meta?.alt" [alt]="hl?.news_image?.meta?.alt">
                </div>
              </div>
              <a class="read-more ps-3" [href]="hl.path.alias">
                <span class="text">Vai alla pagina</span>
                <svg class="icon">
                  <use xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
                </svg>
              </a>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</section> -->